import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class AbstractAssetPlaybackUtility extends AbstractTagClass {
    constructor(argument) {
        super({
            name: 'AbstractAssetPlaybackUtility',
            ...argument
        });
    }
    isIntl() {
        return this?.tag?.tagUtilities?.isInternationalContext(this.tag);
    }
    videoAdsEnabled() {
        return this?.params?.AD?.VIDEOADS?.enabled === true;
    }
}
